export const translations = {
	nav: {
		title: 'Navigatie',
		app: 'Donatie certificaat',
	},
	footer: {
		poweredBy: 'Gemaakt door',
		copyright: '© {{year}} WorldCoo. Alle rechten voorbehouden.',
		termsAndConditions: 'Algemene voorwaarden',
		privacyPolicy: 'Privacybeleid',
	},
	categories: {
		basicNeeds: 'Water en Energie',
		humanRights: 'Mensenrechten',
		education: 'Onderwijs',
		emergency: 'Noodhulp',
		feeding: 'Honger en Voedselzekerheid',
		environment: 'Milieu',
		habitat: 'Huisvesting en Armoede',
		health: 'Gezondheid',
	},
	statistics: {
		campaigns: 'Campagnes',
		donations: 'Donaties',
		collected: 'Opgehaald',
		collectedFromBudget: 'Doel van {{budget}}',
	},
	filters: {
		year: 'Jaar',
		state: 'Status',
		cause: 'Doel',
		active: 'Actief',
		finished: 'Voltooid',
		default: 'Standaard',
		toggle: '{{value}} omschakelen',
	},
	actions: {
		close: 'Sluiten',
		search: 'Zoek naar alles',
		filter: 'Filteren',
		viewCampaign: 'Campagne bekijken',
		makeDonation: 'Doneren',
		donate: 'Doneren',
		selectLanguage: 'Selecteer taal',
		backToHome: 'Terug naar home',
		funded: 'Gefinancierd',
		clear: 'Filters wissen',
		apply: 'Toepassen',
		goBack: 'Terug',
		previous: 'Vorige',
		next: 'Volgende',
	},
	portal: {
		heroButton: 'Begin met doneren',
		campaigns: {
			title: 'Campagnes',
			description: 'Ontdek onze initiatieven en kies het doel dat je het meest inspireert',
			notFound: 'Geen campagnes',
		},
		campaignFunded: 'Campagne gefinancierd',
		percentageFunded: '{{percentage}}% Gefinancierd',
		aCampaignFrom: 'Een campagne van: {{ngoName}}',
		beneficiaries: 'Begunstigden',
		directBeneficiaries: '{{count}} direct',
		indirectBeneficiaries: '{{count}} indirect',
		sdgs: {
			title: 'Duurzame Ontwikkelingsdoelen',
			1: 'Geen Armoede',
			2: 'Geen Honger',
			3: 'Goede Gezondheid en Welzijn',
			4: 'Kwaliteitsonderwijs',
			5: 'Gendergelijkheid',
			6: 'Schoon Water en Sanitair',
			7: 'Betaalbare en Duurzame Energie',
			8: 'Waardig Werk en Economische Groei',
			9: 'Industrie, Innovatie en Infrastructuur',
			10: 'Ongelijkheid Verminderen',
			11: 'Duurzame Steden en Gemeenschappen',
			12: 'Verantwoorde Consumptie en Productie',
			13: 'Klimaatactie',
			14: 'Leven in het Water',
			15: 'Leven op het Land',
			16: 'Vrede, Justitie en Sterke Instellingen',
			17: 'Partnerschap om Doelstellingen te Bereiken',
		},
	},
	faq: {
		title: 'Veelgestelde vragen',
		description: 'Antwoorden op de meest gestelde vragen van onze donateurs.',
	},
	campaign: {
		objectives: 'Campagnedoelen',
		description: 'Beschrijving',
		activities: 'Activiteiten',
		beneficiaries: 'Wie profiteert?',
		updatesAndLinks: 'Meer informatie en links',
		from: 'Van:',
		until: 'Tot:',
	},
	campaigns: {
		notTranslated: 'Dit project is nog niet beschikbaar in jouw taal.',
	},
	placeholders: {
		amount: 'Ander bedrag',
	},
	donate: {
		title: 'Doe je donatie',
		details: {
			title: 'Voeg je gegevens toe om door te gaan',
			subtitle: 'Vul je gegevens in om je donatie te voltooien. Je kunt hier ook je fiscaal certificaat aanvragen.',
		},
		certificate: {
			title: 'Krijg tot {{amount}} terug',
			subtitle: 'Certificeer uw donatie met één klik en het verschijnt automatisch in uw concept-belastingaangifte.',
		},
	},
	errors: {
		required: 'Dit veld is verplicht',
		invalidExtref: 'De code is ongeldig, deze moet dit formaat volgen: {{format}}',
		email: 'Het e-mailadres is onjuist geformatteerd.',
		emailAlreadyExists: 'Dit e-mailadres is al in gebruik.',
		password: 'Je wachtwoord moet 6 tekens of meer bevatten.',
		confirmationCode: 'Voer de bevestigingscode in.',
		documentType: 'Ongeldig documenttype',
		termsAndConditions: 'Je moet de algemene voorwaarden accepteren',
		amount: 'Selecteer of voer een geldig bedrag in.',
		signIn: 'Fout bij het inloggen',
		emailsDoNotMatch: 'E-mailadressen komen niet overeen.',
		passwordsDoNotMatch: 'Wachtwoorden komen niet overeen.',
		imageFormat: 'Sleep een afbeeldingsbestand',
		camera: 'Kan geen toegang krijgen tot de camera. Zorg ervoor dat je toestemming hebt gegeven.',
		expiredCode: 'De code is verlopen.',
		codeMismatch: 'De code is onjuist. Probeer het opnieuw.',
		notAuthorized: 'Onjuiste inloggegevens. Probeer het opnieuw.',
		userDoesNotExist: 'De gebruiker bestaat niet.',
		userNotConfirmed: 'Gebruiker niet bevestigd. Bevestig eerst je e-mailadres.',
		userAlreadyConfirmed: 'De gebruiker is al bevestigd.',
		documentNumberExists: 'Het documentnummer is al in gebruik.',
		limitExceeded: 'Je hebt het pogingenlimiet bereikt. Probeer het later opnieuw.',
		invalidPassword: 'Het wachtwoord is ongeldig, moet minimaal 6 tekens bevatten en mag geen spaties bevatten.',
		captchaFailed: 'CAPTCHA verification failed. Please try again.',
		internal: 'Sorry, er is een probleem opgetreden, ons team is al geïnformeerd, probeer het later opnieuw.',
	},
	documentTypes: {
		id: 'ID-kaart',
		passport: 'Paspoort',
		taxId: 'Fiscaal identificatienummer',
		nie: 'NIE',
		others: 'Overige',
	},
	labels: {
		code: 'Code',
		email: 'E-mail',
		repeatEmail: 'Herhaal je e-mail',
		password: 'Wachtwoord',
		confirmPassword: 'Bevestig wachtwoord',
		amount: 'Donatiebedrag',
		documentType: 'Documenttype',
		documentNumber: 'Documentnummer',
		name: 'Naam',
		lastName: 'Achternaam',
		streetName: 'Straatnaam',
		streetNumber: 'Nummer',
		additionalInfo: 'Aanvullende informatie',
		postalCode: 'Postcode',
		city: 'Stad',
		country: 'Land',
		region: 'Regio',
		province: 'Provincie',
		certificate: 'Ik wil een fiscaal certificaat ontvangen',
		termsAndConditions1:
			'Deze informatie wordt alleen gedeeld met de ontvangende organisaties van je donaties om het bijbehorende fiscale certificaat te genereren. Lees de ',
		termsAndConditions2: 'algemene voorwaarden',
		language: 'Taal',
	},
	checkout: {
		title: 'Betaalmethode',
	},
	recaptcha: {
		description: 'beschermd door reCAPTCHA.',
		privacy: 'Privacy',
		terms: 'Voorwaarden',
	},
	thanks: {
		title: 'Bedankt\n voor je donatie!',
		description:
			'Je ontvangt binnenkort een bevestigingsmail met alle details. Samen bouwen we aan een betere toekomst!',
	},
	termsAndConditions: {
		title: 'Gegevensbescherming Voorwaarden',
		labelText: 'Ik heb gelezen, begrepen en accepteer de voorwaarden van ',
		labelLink: 'Gegevensbescherming van {{name}}',
		accept: 'Ik heb gelezen, begrepen en accepteer',
		responsible: {
			title: 'Verantwoordelijke',
			description: 'WORLDCOO S.L.',
		},
		purpose: {
			title: 'Doel',
			description:
				'Beheer van de zakelijke relatie in al haar aspecten, evenals uw donatie en uw certificaataanvraag, en het verzenden van commerciële communicatie via elektronische middelen.',
			descriptionNgo:
				'Fondsenwerving voor NGO-projecten, u op de hoogte houden van de NGO en de ontwikkeling van het project waarvoor u fondsen heeft gedoneerd en het uitgeven van fiscale aftrekcertificaten.',
		},
		legitimacy: {
			title: 'Legitimiteit',
			description: 'De wettelijke grondslag voor de verwerking van uw gegevens is het verkrijgen van uw toestemming.',
		},
		recipients: {
			title: 'Ontvangers',
			description:
				'Gegevens worden niet overgedragen aan derden, tenzij er een wettelijke verplichting is om dit te doen.',
		},
		rights: {
			title: 'Rechten',
			description:
				'U heeft het recht om toegang te krijgen tot, te corrigeren en te verwijderen van gegevens, evenals andere rechten, zoals uitgelegd in de aanvullende informatie.',
		},
		additionalInfo: {
			title: 'Aanvullende informatie',
			description:
				'U kunt aanvullende en gedetailleerde informatie over Gegevensbescherming raadplegen op onze pagina <a href="https://www.worldcoo.com/gdpr">web</a> of door contact op te nemen met <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>.',
			descriptionNgo:
				'U kunt de aanvullende en gedetailleerde informatie over Gegevensbescherming raadplegen op de website van elke NGO.\n\n<b>{{ngoName}}</b>',
		},
	},
};
